import Cookies from 'js-cookie'
import logger from '@adc/logger'
import { cookies } from '@adc/constants'
import * as blueprint from '@adc/blueprint'
import { FeatureFlags } from '@adc/ui-adc'
import { ListingPageType } from '@adc/blueprint/lib/listing/pdp/hooks'
import { storeListing } from 'common/actions/listing'
import { ListingPageActionsType } from 'common/context/listing'
import { refreshUser } from '../actions/user'
import {
  fetchDataForNewlyAuthenticatedUser,
  fetchGraphUserDetails,
} from '../providers/user'
import { storeFlags } from '../actions/featureFlags'
import { getAiAssistantPDPTargetingContext } from '../utils/getAiAssistantPDPTargetingContext'

interface FetchDataForNewlyAuthenticatedUserAndTokensParams {
  dispatch: any
  listing: ListingPageType['currentListing']
  featureFlags: FeatureFlags
  refreshPageData: ListingPageActionsType['refresh']
}

const fetchDataForNewlyAuthenticatedUserAndTokens = ({
  dispatch,
  listing,
  featureFlags,
  refreshPageData,
}: FetchDataForNewlyAuthenticatedUserAndTokensParams) => {
  const isRemoteBiddingEnabled =
    featureFlags['fe.resi.enable-web-remote-bidding']
  /**
   * Passing context so that we can apply it when resolving flags (client-side)
   * This mimics the context used in server/index.js.  We can probably ditch gpid SOON!
   */
  refreshPageData(listing)
  // TODO: Create smaller query to just update feature flags.
  // Only leaving it for now because we still have property in our code
  fetchDataForNewlyAuthenticatedUser(
    listing.listing_id,
    isRemoteBiddingEnabled,
    {
      seller_code: listing?.seller_plan?.seller_plan_code,
      'fe.resi.ai-assistant': getAiAssistantPDPTargetingContext(listing),
    }
  )
    .then((data: any) => {
      let flagForceOverrides = {}
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      const flags = data.current_user?.feature_flags || {}
      try {
        // @ts-ignore leave it
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
        flagForceOverrides = Cookies.get(cookies.FEATURE_FLAG_OVERRIDES)
      } finally {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        dispatch(
          storeFlags({
            ...flags,
            ...flagForceOverrides,
          })
        )
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        dispatch(storeListing(data.listing))
      }
    })
    .catch(e =>
      logger.error('Failed to Fetch newly authenticated user data', e)
    )
}

interface OnAuthenticationCompleteProps {
  user: blueprint.primitives.AuctionUser
  refreshPageData: ListingPageActionsType['refresh']
  listing: ListingPageType['currentListing']
}

export const onAuthenticationComplete =
  ({ user, refreshPageData, listing }: OnAuthenticationCompleteProps) =>
  async (dispatch: any, getState: any) => {
    fetchDataForNewlyAuthenticatedUserAndTokens({
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      dispatch,
      listing,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
      featureFlags: getState().featureFlags as FeatureFlags,
      refreshPageData,
    })

    let graphUserDetails
    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      graphUserDetails = await fetchGraphUserDetails()
    } catch (err) {
      logger.error(err)
    } finally {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      dispatch(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        refreshUser(graphUserDetails?.logged_in ? graphUserDetails : user)
      )
    }
  }
